import React from "react";

/**
 * Envelope line-art icon — fe-unverified-banner-and-cues. Stroke-only
 * (fill="none"), same convention as this folder's other hand-authored icons
 * (see HouseLineArt.jsx): `color` defaults to the app's existing
 * PrimaryPurple500 token value (#9B5AF8), no new colour introduced.
 */
const EnvelopeLineArt = ({ color = "#9B5AF8", width = 22, height = 22, strokeWidth = 8 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect
      x="12"
      y="30"
      width="104"
      height="68"
      rx="8"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinejoin="round"
    />
    <path
      d="M16 34 L64 72 L112 34"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EnvelopeLineArt;
